import {
  BooleanInput,
  CreateButton,
  Datagrid,
  EditButton,
  FunctionField,
  List,
  TextField,
  TextInput,
} from 'react-admin';

import { DataTableListActions } from 'src/client/components/data-table-list-actions';
import { ESTDateField } from 'src/client/components/custom-ra-fields/est-date-field';
import { includesInsensitive } from 'src/client/components/forms/form-utils';
import { ProductArchiveButton } from './ProductArchiveButton';
import { formatDefaultTargetingForInput } from './json';

type ProductRecord = {
  archivedAt?: string | null;
  defaultTargeting?: unknown;
};

const productFilters = [
  <TextInput label="Product Name" source="name" {...includesInsensitive} alwaysOn />,
  <TextInput label="External PIO ID" source="externalPioId" {...includesInsensitive} />,
  <BooleanInput label="Include Archived" source="includeArchived" alwaysOn />,
];

const ProductListActions = () => (
  <DataTableListActions filters={productFilters}>
    <CreateButton />
  </DataTableListActions>
);

export const ProductList = () => (
  <List
    actions={<ProductListActions />}
    perPage={25}
    sort={{ field: 'name', order: 'ASC' }}
    filterDefaultValues={{ includeArchived: false }}
  >
    <Datagrid rowClick="show" bulkActionButtons={false}>
      <TextField source="name" />
      <TextField source="externalPioId" label="External PIO ID" />
      <FunctionField
        source="defaultTargeting"
        label="Default Targeting"
        render={(record: ProductRecord) => formatDefaultTargetingForInput(record.defaultTargeting)}
      />
      <FunctionField
        source="archivedAt"
        label="Status"
        render={(record: ProductRecord) => (record.archivedAt ? 'Archived' : 'Active')}
      />
      <ESTDateField source="updatedAt" label="Updated At" showTime />
      <ProductArchiveButton />
      <EditButton />
    </Datagrid>
  </List>
);
